import { IReactSelectOptionObject } from "@atman/design-system";

export const reactSelectNoneOption: IReactSelectOptionObject<string | undefined> = {
    value: undefined,
    label: "none".localize(),
};
